import { Add20Regular } from '@fluentui/react-icons';
import { AddSkillButtonCategoryMobile } from '../styles/SkillsMainContainer.styled';
import { EmployeeSkillsByCategoryDTO } from 'src/tabs/models/SkillsInterfaces';

interface AddSkillsButtonCategoryMobileProps {
  setSelectedCategory: React.Dispatch<React.SetStateAction<string>>;
  setAddSkillPopup: React.Dispatch<React.SetStateAction<boolean>>;
  skillDTO?: EmployeeSkillsByCategoryDTO;
}

export const AddSkillsButtonCategoryMobile = ({
  setAddSkillPopup,
  setSelectedCategory,
  skillDTO,
}: AddSkillsButtonCategoryMobileProps) => {
  return (
    <AddSkillButtonCategoryMobile
      onClick={(e) => {
        e.stopPropagation();
        setSelectedCategory(skillDTO.category.value);
        setAddSkillPopup(true);
      }}
    >
      <Add20Regular />
    </AddSkillButtonCategoryMobile>
  );
};
